export const selectNotificationEntriesMap = state =>
  state.notifications.entries;
